import React, { useState } from 'react';
// @ts-ignore
import styles from './PlannedQuestionnairesWrapper.module.scss';
import QuestionnaireList from '../../../../Components/QuestionnaireList/QuestionnaireList';
import PlannedQuestionnairesFilter, {
	PlannedQuestionnairesFilterValues,
} from './PlannedQuestionnairesFilter/PlannedQuestionnairesFilter';

interface Props {
	patientId?: string;
}

const PlannedQuestionnairesWrapper: React.FC<Props> = ({ patientId }) => {
	const [filter, setFilter] = useState<PlannedQuestionnairesFilterValues>({});

	return (
		<div className={styles.wrapper}>
			<PlannedQuestionnairesFilter onFilter={setFilter} patientId={patientId} />
			<QuestionnaireList filter={filter} showPatientName />
		</div>
	);
};

export default PlannedQuestionnairesWrapper;
